import apiClient from './client'

// 登录请求接口
export interface LoginRequest {
  username: string
  password: string
}

// 登录响应接口
export interface LoginResponse {
  access_token: string
  refresh_token: string
  user: {
    id: string
    username: string
    email: string
    role: string
    avatar?: string
    created_at: string
  }
}

// 刷新token请求接口
export interface RefreshTokenRequest {
  refresh_token: string
}

// 刷新token响应接口
export interface RefreshTokenResponse {
  access_token: string
  refresh_token: string
}

// 用户信息接口
export interface UserInfo {
  id: string
  username: string
  email: string
  role: string
  avatar?: string
  created_at: string
}

// 单点登录回调请求
export interface SSOCallbackRequest {
  token: string
}

// 单点登录回调响应
export interface SSOCallbackResponse {
  access_token: string
  refresh_token: string
  user: UserInfo
}

// 注册请求接口
export interface RegisterRequest {
  username: string
  email: string
  password: string
}

export interface RegisterRequest {
  username: string
  email: string
  password: string
}

// 认证API
export const authApi = {
  // 登录
  login: async (data: LoginRequest): Promise<LoginResponse> => {
    const response = await apiClient.post('/v1/auth/login', data)
    return response.data
  },

  // 注册
  register: async (data: RegisterRequest): Promise<LoginResponse> => {
    const response = await apiClient.post('/v1/auth/register', data)
    return response.data
  },

  // 登出
  logout: async (): Promise<void> => {
    await apiClient.post('/v1/auth/logout')
  },

  // 获取当前用户信息
  getCurrentUser: async (): Promise<UserInfo> => {
    const response = await apiClient.get('/v1/auth/me')
    return response.data
  },

  // 刷新token
  refreshToken: async (refreshToken: string): Promise<RefreshTokenResponse> => {
    const response = await apiClient.post('/v1/auth/refresh', {
      refresh_token: refreshToken
    })
    return response.data
  },

  // 单点登录回调
  ssoCallback: async (token: string): Promise<SSOCallbackResponse> => {
    const response = await apiClient.post('/v1/auth/sso/callback', { token })
    return response.data
  },

  // 验证token（用于单点登录）
  verifyToken: async (token: string): Promise<{ valid: boolean; user?: UserInfo }> => {
    try {
      const response = await apiClient.post('/v1/auth/verify', { token })
      return response.data
    } catch {
      return { valid: false }
    }
  }
}

export default authApi